function CrossSvg() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group">
        <path
          id="Vector"
          d="M3.59619 3.40381L12.7887 12.5963"
          stroke="#0E0F0F"
          strokeWidth="1.95001"
          strokeLinecap="round"
        />
        <path
          id="Vector_2"
          d="M3.59619 12.5962L12.7886 3.4038"
          stroke="#0E0F0F"
          strokeWidth="1.95001"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
}

export default CrossSvg;
